import { lazy, Suspense, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const ChatWidget = lazy(() => import("./ChatWidget"));

/**
 * Lazy mount-point for the editorial chat agent.
 *
 * Behavior:
 *   - Hidden on /admin/* routes (private panel, no public chat needed).
 *   - On public routes, mounts the FAB after the page idles so first paint
 *     stays fast. The actual widget JS is only loaded by Suspense when the
 *     user is on a public page.
 */
export default function ChatWidgetMount() {
  const location = useLocation();
  const [ready, setReady] = useState(false);

  const isAdmin = location.pathname.startsWith("/admin");

  useEffect(() => {
    if (isAdmin) return;
    if (typeof window === "undefined") return;
    const idle = window.requestIdleCallback || ((cb) => window.setTimeout(cb, 600));
    const cancel = window.cancelIdleCallback || window.clearTimeout;
    const handle = idle(() => setReady(true));
    return () => cancel(handle);
  }, [isAdmin]);

  if (isAdmin || !ready) return null;
  return (
    <Suspense fallback={null}>
      <ChatWidget />
    </Suspense>
  );
}
